import React from 'react';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import config from 'config';
import styles from './DonateButton.scss';

type Props = {
  isActive: boolean;
  name: string;
  pageSection: string;
  donate: (options: { pageSection: string }) => void;
};

class DonateButton extends React.Component<Props> {
  render() {
    const { isActive, name, pageSection, donate } = this.props;

    const buttonClass = classNames('jg-btn', {
      'is-disabled': !isActive,
    });

    const enrolledSlugs = Buffer.from(
      '["cf_growth_remind_me_later", "cf_growth_share_button_modal", "cf_growth_help_share_my_story"]'
    ).toString('base64');
    return (
      <a
        data-marker="donate-button"
        onClick={() => donate({ pageSection })}
        href={`${
          config.CROWDFUNDING_BASE_URI
        }/${name}/donate?pageSection=${pageSection}&enrol=${enrolledSlugs}`}
        className={buttonClass}
        styleName="fixed-donate-button"
      >
        Donate Now
      </a>
    );
  }
}

export default CSSModules(DonateButton, styles);



// WEBPACK FOOTER //
// ./src/components/Page/DonateButton.tsx